import React from "react";
import ListCategoryUserSitePublisher from "./ListCategoryUserSitePublisher";
import helperNumber from "../../../helpers/numbers";
import helpersTime from "../../../helpers/time";
import ListCustomers from "./ListCustomers";
import { Link } from "react-router-dom";

function GroupPublisher() {
  return (
    <>
      <div
        className="tab-pane fade border border-3 p-2 rounded"
        id="group-publisher"
        role="tabpanel"
        aria-labelledby="group-publisher-tab"
      >
        <ListCustomers />
      </div>
    </>
  );
}

export default GroupPublisher;
